<template>
  <el-select
    v-model="packType"
    :disabled="disabled"
    size="small"
    style="width: 100%;"
    @change="value => $emit('change', value)"
  >
    <el-option
      v-for="unit in measureUnits"
      :key="unit.value"
      :value="unit.value"
      :label="unit.label"
    />
  </el-select>
</template>

<script>
import measureUnits from '../../measureUnits';

export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    defaultPackType: {
      type: String,
      default() {
        return null;
      },
      required: false,
    },
  },
  data() {
    return {
      measureUnits,
      packType: '',
    };
  },
  watch: {
    defaultPackType(newVal) {
      this.packType = newVal;
    }
  },
  mounted() {
    this.packType = this.defaultPackType;
  },
};
</script>
